import { PricingCouponFailureReason } from "@sticker-giant/sg-frontend-common";
import { CustomerFacingErrorMessages } from "@/constants/CustomerFacingErrorMessages";

const ERROR_MESSAGES: { [key in PricingCouponFailureReason]: string } = {
  [PricingCouponFailureReason.CUSTOMER_RESTRICTED]: CustomerFacingErrorMessages.promoCodeCustomerRestricted,
  [PricingCouponFailureReason.EXCESSIVE_ITEM_QUANTITY]: CustomerFacingErrorMessages.promoCodeExcessiveItemQuantity,
  [PricingCouponFailureReason.EXCESSIVE_ITEM_VALUE]: CustomerFacingErrorMessages.promoCodeExcessiveItemValue,
  [PricingCouponFailureReason.EXCESSIVE_ORDER_SIZE]: CustomerFacingErrorMessages.promoCodeExcessiveOrderSize,
  [PricingCouponFailureReason.EXCESSIVE_ORDER_VALUE]: CustomerFacingErrorMessages.promoCodeExcessiveOrderValue,
  [PricingCouponFailureReason.EXPIRED]: CustomerFacingErrorMessages.promoCodeExpired,
  [PricingCouponFailureReason.GREATER_DISCOUNT_EXISTS]: CustomerFacingErrorMessages.promoCodeGreaterDiscountExists,
  [PricingCouponFailureReason.INACTIVE]: CustomerFacingErrorMessages.promoCodeInactive,
  [PricingCouponFailureReason.INSUFFICIENT_ITEM_QUANTITY]:
    CustomerFacingErrorMessages.promoCodeInsufficientItemQuantity,
  [PricingCouponFailureReason.INSUFFICIENT_ITEM_VALUE]: CustomerFacingErrorMessages.promoCodeInsufficientItemValue,
  [PricingCouponFailureReason.INSUFFICIENT_ORDER_SIZE]: CustomerFacingErrorMessages.promoCodeInsufficientOrderSize,
  [PricingCouponFailureReason.INSUFFICIENT_ORDER_VALUE]: CustomerFacingErrorMessages.promoCodeInsufficientOrderValue,
  [PricingCouponFailureReason.INSUFFICIENT_USES_REMAINING]:
    CustomerFacingErrorMessages.promoCodeInsufficientUsesRemaining,
  [PricingCouponFailureReason.ITEM_RESTRICTED]: CustomerFacingErrorMessages.promoCodeItemRestricted,
  [PricingCouponFailureReason.MAXIMUM_CUSTOMER_USES_REACHED]:
    CustomerFacingErrorMessages.promoCodeMaximumCustomerUsesReached,
  [PricingCouponFailureReason.NO_APPLICABLE_ITEMS]: CustomerFacingErrorMessages.promoCodeNoApplicableItems,
  [PricingCouponFailureReason.REORDER_RESTRICTED]: CustomerFacingErrorMessages.promoCodeReorderRestricted,
  [PricingCouponFailureReason.NOT_FOUND]: CustomerFacingErrorMessages.invalidPromoCode,
  [PricingCouponFailureReason.NEW_CUSTOMERS_ONLY]: CustomerFacingErrorMessages.promoCodeForNewCustomersOnly,
  [PricingCouponFailureReason.INVALID_ITEM_DIMENSIONS]: CustomerFacingErrorMessages.invalidItemDimensions,
};

export function getPromoCodeErrorMessage(failureReason?: PricingCouponFailureReason): string {
  if (!failureReason) return CustomerFacingErrorMessages.unableToApplyPromo;
  return ERROR_MESSAGES[failureReason];
}
